import React from 'react';
import { MenuItem, Select, Box, Theme } from '@mui/material';
import type { SxProps } from '@mui/material';
import type { SelectChangeEvent } from '@mui/material/Select';
import { FileType } from 'API';
import { ALL_FILE_TYPES } from 'shared/constants';
import { resolvers } from 'shared/enums';

const fileTypeResolver = resolvers.FileType;

interface Props {
  className?: string;
  sx?: SxProps<Theme>;
  disabled?: boolean;
  fileTypeOptions?: Array<FileType>;
  onChange: (
    e: SelectChangeEvent<any>
  ) => void;
  placeholder?: string;
  value?: FileType | null;
}

const FileTypeSelect: React.FC<Props> = ({
  className, sx, disabled, placeholder, fileTypeOptions, onChange, value,
}: Props) => (
  <Select
    name="fileType"
    className={className}
    sx={sx}
    onChange={onChange}
    value={value || ''}
    displayEmpty
    disabled={disabled || !!(fileTypeOptions && fileTypeOptions.length === 0)}
    renderValue={(selected: any) => {
      if (selected.length === 0) {
        return (
          <Box component="span" sx={(t) => ({ color: t.palette.text.primary, fontWeight: t.typography.fontWeightRegular, fontSize: '0.875rem' })}>
            {placeholder || 'What type of document is this?'}
          </Box>
        );
      }

      return fileTypeResolver(selected);
    }}
  >
    {(fileTypeOptions || ALL_FILE_TYPES).map((option) => (
      <MenuItem key={option} value={option}>
        {fileTypeResolver(option)}
      </MenuItem>
    ))}
  </Select>
);

export default FileTypeSelect;
